<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                Edit About Us
            </h2>
            <v-form name="editForm" ref="editForm">

                <div class="mb-2 p-2">
                    <w-y-s-i-w-y-g
                        v-if="activeEditor1"
                        v-model="modelObject.body"
                    />
                </div>
                <div class="tw-flex w-flex-row tw-w-full tw-gap-4 tw-pb-4">
                    <div
                        v-if="activeOption('main_image')"
                        class="tw-flex tw-flex-col tw-w-1/4 tw-gap-2"
                    >
                        <v-file-input
                            v-model="modelObject.new_image_desktop"
                            label="Image desktop"
                            dense
                            outlined
                            hide-details
                            :prepend-icon="null"
                        >
                        </v-file-input>
                        <v-file-input
                            v-model="modelObject.new_image_mobile"
                            label="Image mobile"
                            dense
                            outlined
                            hide-details
                            :prepend-icon="null"
                        >
                        </v-file-input>
                    </div>
                </div>
            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditAboutUsModal",
    components: {
        WYSIWYG
    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'refElement': {
            type: String,
            required: false
        },
        'constants': {
            type: Object,
            required: true
        },
        'valuelists': {
            type: Object,
            required: false
        },
        'activeOptions': {
            // The options that should be active for this usage. Available options are : main_image, documents
            type: Array,
            required: false,
            default: () => []
        },
    },
    updated() {
        //
    },
    mounted() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: structuredClone(this.modelProp) || {}, // Don't want to modify the original model while typing in the editor, clone used.
            modelDefault: {
                id: null,
                body: null,
                new_image_desktop: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            activeEditor1: false
        }
    },
    computed: {
        dialog_width() {
            return '80%'
        },
        // is_edit_mode() {
        //     return this.mode == 'Edit' ? true : false
        // }
    },
    methods: {
        initEditor() {
            this.$nextTick(() => {
                this.activeEditor1 = true
            })
        },
        activeOption(option) {
            if (this.activeOptions.includes(option)) {
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            //let payload = this.modelObject

            if (this.$refs.editForm.validate()) {

                this.saveLoading = true
                let formData = new FormData()
                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key]);
                    } else {
                        formData.append(key, '');
                    }
                }

                var url = route('content.update', this.modelObject.id)
                formData.append("_method", "put")

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.modelObject.body = response.data.content.body
                            this.$inertia.reload({only: ['input']})
                            this.$emit('updatedContent', this.$root.sanitizeAndTruncateHTML(response.data.content.body, 1000), this.refElement)

                            this.saveLoading = false
                        } else if (response.data?.error) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error);
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing
                this.activeEditor1 = false
            } else {
                // Opening
                this.initEditor()
            }
        },
    },
}
</script>
<style scoped>
</style>
